import React, { useRef } from 'react';
import styled, { keyframes } from 'styled-components';

import madnessHook from 'hooks/madness/madness.hook';
import Paths from 'components/paths/Paths';

const Main = styled.main`
  background: #111111;
  height: 100vh;
`;
const texture = 'data:image/png;base64,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';

const FadeIn = keyframes`
    0%{
        opacity: 0;
    }
    75%{
        opacity: 0.5;
    }
    100%{
        opacity: 1;
    }
`;

const Section = styled.section`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 75%;
  height: auto;
  margin: 0 auto;
  padding: 3em;
  font-family: "Shadows Into Light", sans-serif;
`;

const ParchmentBackground = styled.div`
  position: absolute;
  display: flex;
  width: 75%;
  top: 0%;
  left: 50%;
  min-height: 75vh;
  transform: translate(-50%, 0);
  margin: 2rem 0;
  padding: 4rem;
  box-shadow: 2px 3px 20px #c9611c, 0 0 225px #79180b inset;
  background: #c49a5b;
  filter: url(#ripped);
  background-image: url(${texture});
`;

const Title = styled.h1`
  font-size: 6rem;
  text-align: center;
  opacity: 0;
  animation: ${FadeIn} 1.5s linear forwards;
  margin: 1rem 0;
`;
const BorderFilter = () => (
  <svg>
    <filter id="ripped">
      <feTurbulence x="0" y="0" baseFrequency="0.02" numOctaves="5" seed="20" />
      <feDisplacementMap in="SourceGraphic" scale="50" />
    </filter>
  </svg>
);

const IndexPage = () => {
  const parchment = useRef(null);
  const container = useRef(null);
  const madness = madnessHook().sort((prev, next) => prev.node.order - next.node.order);
  // useEffect(() => {
  //   parchment.current.style.height = `${container.current.offsetHeight}px`;
  // });
  return (
    <Main>
      <ParchmentBackground ref={parchment} />
      <Section ref={container}>
        <Title>Madness Ensues</Title>
        <Paths madness={madness} />
      </Section>
      <BorderFilter />
    </Main>
  );
};

export default IndexPage;
